interface IPhoneTapReminderProps {
  show: boolean;
  onDismiss: () => void;
}

export const IPhoneTapReminder = ({ show, onDismiss }: IPhoneTapReminderProps) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'rgba(0, 0, 0, 0.9)',
        color: 'white',
        padding: '20px',
        borderRadius: '12px',
        textAlign: 'center',
        zIndex: 10000,
        maxWidth: '280px',
        fontSize: '16px',
        lineHeight: '1.4',
      }}
      onClick={onDismiss}
    >
      <div style={{ marginBottom: '12px', fontSize: '24px' }}>👆</div>
      <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
        Tap to continue
      </div>
      <div style={{ fontSize: '14px', opacity: 0.8 }}>
        Keep the conversation active by tapping the screen
      </div>
    </div>
  );
};